import React from "react";
import { Autocomplete } from "@react-google-maps/api";
import { useState } from "react";
import { useMapContext } from "./MapContext";

export default function Search() {
  const { map } = useMapContext();
  const [autocomplete, setAutocomplete] = useState(null);
  const onLoad = (autocomplete) => {
    setAutocomplete(autocomplete);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      map.setCenter(place.geometry.location);
      map.setZoom(10);
    }
  };

  return (
    <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
      <input
        type="text"
        placeholder="zu Adresse oder Ort"
        style={{
          border: `1px solid #eee`,
          width: `100%`,
          height: `40px`,
          padding: `0 15px`,
          fontSize: `18px`,
          outline: `none`,
          textOverflow: `ellipses`,
          borderRadius: 2,
          boxShadow: "rgb(0 0 0 / 30%) 0px 1px 4px -1px",
        }}
      />
    </Autocomplete>
  );
}
